/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionShootdown
 */
export interface OutputUavMissionShootdown {
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionShootdown
     */
    coords?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionShootdown
     */
    occurredAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionShootdown
     */
    reportedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionShootdown
     */
    reportedByName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionShootdown
     */
    seq?: number;
}

/**
 * Check if a given object implements the OutputUavMissionShootdown interface.
 */
export function instanceOfOutputUavMissionShootdown(value: object): boolean {
    return true;
}

export function OutputUavMissionShootdownFromJSON(json: any): OutputUavMissionShootdown {
    return OutputUavMissionShootdownFromJSONTyped(json, false);
}

export function OutputUavMissionShootdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionShootdown {
    if (json == null) {
        return json;
    }
    return {
        
        'coords': json['coords'] == null ? undefined : json['coords'],
        'occurredAt': json['occurredAt'] == null ? undefined : json['occurredAt'],
        'reportedBy': json['reportedBy'] == null ? undefined : json['reportedBy'],
        'reportedByName': json['reportedByName'] == null ? undefined : json['reportedByName'],
        'seq': json['seq'] == null ? undefined : json['seq'],
    };
}

export function OutputUavMissionShootdownToJSON(value?: OutputUavMissionShootdown | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coords': value['coords'],
        'occurredAt': value['occurredAt'],
        'reportedBy': value['reportedBy'],
        'reportedByName': value['reportedByName'],
        'seq': value['seq'],
    };
}

